import React from "react";
import Header from "../basic/Header";
import RegisterForCourse from "../enroll-for-course/RegisterForCourse";

class RemoteInternships extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            program: 'Remote_Internship',
            course: 'Remote_Internship'
        };

    }

    render() {
        return (
            <div>
                <Header title={"Remote Internships"} subTitleText={"The Remote Internships program matches you with a personal Career Coach who will find your perfect remote internship, optimize your professional profile, and teach you in-demand skills."}/>
                <div className="row">
                    <div className="container-fluid" style={{display: 'flex', justifyContent: 'center'}}>
                        <div className="col-md-8">
                            <h4 style={{display: 'flex', justifyContent: 'center'}}>Apply for the Remote Internship Program</h4>
                            <hr />
                            <RegisterForCourse program={this.state.program} course={this.state.course}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RemoteInternships.propTypes = {};

export default RemoteInternships;
